import { VariableStemDto } from "app/ApiClient";
import { LoadingState } from "types";

export type StemsState = {
  loading: LoadingState;
  stems: VariableStemDto[];
};
export const initialStemsState: StemsState = {
  loading: LoadingState.idle,
  stems: [],
};
